module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "conteudo"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('banner')], 1), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('noticias', {
    attrs: {
      "reference": true
    }
  })], 1), _vm._m(0)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('sobre')], 1), _vm._m(1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('diretorias', {
    attrs: {
      "breakpoints": [
        [768, 3],
        [1024, 4]
      ]
    }
  })], 1), _vm._m(2)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('coordenadorias', {
    attrs: {
      "breakpoints": [
        [768, 1],
        [1024, 2]
      ]
    }
  })], 1), _vm._m(3), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('assessoria')], 1)])]), _c('links-importantes')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "-normal"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "-normal"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "-normal"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 visible-xs"
  }, [_c('hr', {
    staticClass: "-normal"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03e69cd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/Index.vue
// module id = 446
// module chunks = 0